module.exports = __webpack_public_path__ + "img/LogoBondinnov.81788643.png";